import React from 'react';
import { useParams } from 'react-router-dom';
import { useGetProjectQuery } from '../features/api/apiSlice';

const ProjectDetailPage = () => {
    const { id } = useParams();
    // console.log(id);
    const { data: project, isLoading, isError, isSuccess } = useGetProjectQuery(id);
    // console.log(project);
    return (
        <div>
            hello from project detail page
        </div>
    );
};

export default ProjectDetailPage;